const MuiInputLabel = {
    styleOverrides: {
        root: {
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '20px',
        },
        sizeSmall: {
            fontSize: '12px',
            lineHeight: '16px',
        }
    }
};

export default MuiInputLabel;
